import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import {
  AboutUsContainer,
  ClarkLogo,
  CustomDotWrapper,
  FirstSlideTextContainer,
  Header,
  Information1stRow,
  Information2ndRow,
  InformationColumn,
  InformationContainer,
  InformationHeader,
  InformationImg,
  InformationParagraph,
  SecondSlideTextContainer,
  SliderContainer,
  SlideText,
  ThirdSlideTextContainer,
} from "./styled";

import { motion } from "framer-motion";
import { OrangeButton } from "../../../components/OrangeButton";

import clarkLogo from "../../../images/clark-green-logo.png";

import sliderImg1 from "../../../images/Home/AboutUs/flotila-clark.jpg";
import forkliftImg from "../../../images/Home/AboutUs/forklift.png";
import learningImg from "../../../images/Home/AboutUs/learning.png";
import offerImg from "../../../images/Home/AboutUs/offer.png";
import sliderImg2 from "../../../images/Home/AboutUs/slider2.jpg";
import sliderImg3 from "../../../images/Home/AboutUs/slider3.jpg";

// Create a custom dot component to be passed into the carousel
const CustomDot = ({ onClick, ...rest }) => {
  const { active } = rest;
  return <CustomDotWrapper active={active} onClick={() => onClick()} />;
};

const AboutUsPage = () => {
  const slidesArray = [
    {
      url: sliderImg1,
      childrenElem: (
        <>
          <FirstSlideTextContainer>
            <Header>Flotila Clark</Header>
            <SlideText>
              S radostí oznamujeme, že naše společnost se stala autorizovaným prodejcem manipulačních vozíků CLARK - americké značky s více než stoletou historií a celosvětovým renomé. Abychom dále
              posouvali úroveň našich služeb, rozšířili jsme naši nabídku o produkty této světově uznávané značky, která je známá svou kvalitou, spolehlivostí a inovacemi v oblasti manipulační
              techniky. V našem sortimentu nyní najdete kompletní řadu vozíků CLARK – ruční paletové vozíky, elektrické i spalovací vysokozdvižné vozíky a také speciální modely pro náročné provozy. Ať
              už hledáte efektivní řešení pro sklad, výrobu nebo náročnější provozní podmínky, s vozíky CLARK získáváte jistotu výkonu a dlouhodobé spolehlivosti.
            </SlideText>
            <OrangeButton style={{ marginTop: "20px" }} url="nove-stroje" text="Podívejte se na nabídku Clark" />
          </FirstSlideTextContainer>
          <ClarkLogo src={clarkLogo} alt="Logo Clark" />
        </>
      ),
    },
    {
      url: sliderImg2,
      childrenElem: (
        <SecondSlideTextContainer>
          <Header>Kdo jsme?</Header>
          <SlideText>
            Naše firma nabízí opravy a údržby vysokozdvižných vozíků přímo u zákazníků. Servis je zajištěn profesionálně vyškolenými servisními techniky vybavenými pojízdnými dílnami.
          </SlideText>
        </SecondSlideTextContainer>
      ),
    },
    {
      url: sliderImg3,
      childrenElem: (
        <ThirdSlideTextContainer style={{ height: "400px" }}>
          <Header>
            Jezdíme přímo k Vám, <br /> po celých Čechách
          </Header>
        </ThirdSlideTextContainer>
      ),
    },
  ];

  const informations = [
    {
      img: learningImg,
      alt: "Obrázek naznačující vysokou zkušenost",
      header: "Více než 20ti letá praxe",
      text: "Servis vysokozdvižných vozíků už děláme spoustu let, a díky získané praxi řešíme problémy s Vašimi vozíky rychle, efektivně a s vysokou kvalitou.",
      id: 0,
    },
    {
      img: offerImg,
      alt: "Obrázek naznačující nabídku služeb",
      header: "Nabízíme opravy a údržby vysokozdvižných vozíků",
      text: "Řešíme opravy, servis, technické kontroly a mnohem víc! Vaše pohodlí je pro nás důležité, a proto nabízíme mnoho služeb, abyste již starosti s vysokozdvižnými vozíky řešili pouze s jednou firmou.",
      id: 1,
    },
    {
      img: forkliftImg,
      alt: "Obrázek vysokozdvižného vozíku",
      header: "Pracujeme s mnoha značkami vysokozdvižných vozíků",
      text: "Už Vás unavuje volat pro každou značku vozíku jinou firmu? Díky nám již nemusíte! Stačí nás kontaktovat, a my se už o vše postaráme!",
      id: 2,
    },
  ];

  // Define the responsive behavior – always 1 item per view
  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
  };

  return (
    <AboutUsContainer>
      <SliderContainer style={{ height: window.innerHeight / 1.5 }}>
        <Carousel
          responsive={responsive}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={10000}
          keyBoardControl={true}
          showDots={true}
          customDot={<CustomDot />}
          arrows={true}
          containerClass="carousel-container"
          itemClass="carousel-item"
        >
          {slidesArray.map((slide, index) => (
            <div
              key={index}
              style={{
                backgroundImage: `url(${slide.url})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: window.innerHeight / 1.5,
                position: "relative",
              }}
            >
              {slide.childrenElem && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                >
                  {slide.childrenElem}
                </div>
              )}
            </div>
          ))}
        </Carousel>
      </SliderContainer>
      <InformationContainer>
        {informations.map((column) => (
          <InformationColumn as={motion.div} initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: false }} key={column.id}>
            <Information1stRow>
              <InformationImg src={column.img} alt={column.alt} />
              <InformationHeader>{column.header}</InformationHeader>
            </Information1stRow>
            <Information2ndRow>
              <InformationParagraph>{column.text}</InformationParagraph>
            </Information2ndRow>
          </InformationColumn>
        ))}
      </InformationContainer>
    </AboutUsContainer>
  );
};

export default AboutUsPage;
